//#region types
import { OptionalExpandableSectionProps } from "models/propTypes/wintFormPropsTypes";
//#endregion
//#region components
import ExpandableSection from "./expandableSection";
//#endregion

const OptionalExpandableSection: React.FC<OptionalExpandableSectionProps> = ({
  isActive,
  summary,
  initiallyOpen,
  children,
}) => {
  return isActive ? (
    <ExpandableSection summary={summary} initiallyOpen={initiallyOpen}>
      {children}
    </ExpandableSection>
  ) : (
    <>{children}</>
  );
};

export default OptionalExpandableSection;
